"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabList = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TabListMixin = require("../../mixins/components/TabListMixin");
var _ToggleButtonGroup = require("../ToggleButtonGroup/ToggleButtonGroup");
var StyledTabList = /*#__PURE__*/(0, _styledComponents.default)(_ToggleButtonGroup.ToggleButtonGroup).withConfig({
  displayName: "StyledTabList",
  componentId: "c11n-8-107-0__sc-12d5wpo-0"
})(["", ""], _TabListMixin.TabListMixin);
exports.StyledTabList = StyledTabList;